import React from "react";
import { navigate } from "gatsby";

import ReviewSlider from "../review-slider/reviewSlider";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import Button from "../../atoms/button/button";

import "./reviewCarousel.scss";

const ReviewCarousel = (props: ReferenciaContenido) => {
  const seeAll = () => {
    navigate(`/ver-todo/?title=${props.tituloGeneral}` +
    `&searchType=filter` +
    `&contentType=Libros` + 
    `&searchParam=word,contentType` +
    `&paramValues=${props.tituloGeneral === "Libros digitales" ? "/-book digital" : "/-book physical"}`,
     {
      state: {},
    });
  };

  return (
    <div className="m-review-carousel">
      <div className="m-review-carousel__upper">
        <h2 className="m-review-carousel__upper-title">
          {props.tituloGeneral}
        </h2>
        <Button
          type="button"
          classname="m-review-carousel__upper-button"
          text={props.tituloBoton}
          isDisabled={false}
          onClickAction={seeAll}
          gtmMark={`gtm${normalizeTwoWords(props.nombreCategoria)}${
            normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(props.tituloBoton)}`
          }
        />
      </div>

      <div className="m-review-carousel__featured">
        {props.referenciaPlantillaContenido && (
          <ReviewSlider 
            reviews={props.referenciaPlantillaContenido} 
            gtmClass={`${normalizeTwoWords(props.nombreCategoria)}${
              normalizeTwoWords(props.tituloGeneral)
            }`} 
          />
        )}
      </div>
    </div>
  );
};

export default ReviewCarousel;
